module.exports = ".row{\r\n    padding: 1em 0px 0px 0px !important;\r\n    margin-bottom: -10px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/land-record/landrecordform/landrecordform.component.css
// module id = ./src/app/planning/land-record/landrecordform/landrecordform.component.css
// module chunks = main